import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const listRooms = () => {
  return axiosInstance.get(`${URLS.chat}/rooms/`);
};

const createGroupRoom = (groupId) => {
  return axiosInstance.post(`${URLS.chat}/rooms/group/`, { group_id: groupId });
};

const createTeamRoom = (teamId) => {
  return axiosInstance.post(`${URLS.chat}/rooms/team/`, { team_id: teamId });
};

const createDmRoom = (otherUserId) => {
  return axiosInstance.post(`${URLS.chat}/rooms/dm/`, { other_user_id: otherUserId });
};

const fetchMessages = (roomId) => {
  return axiosInstance.get(`${URLS.chat}/messages/`, { params: { room_id: roomId } });
};

const sendMessage = (roomId, message) => {
  return axiosInstance.post(`${URLS.chat}/messages/send/`, { room_id: roomId, message });
};

const sendMedia = (payload) => {
  return axiosInstance.post(`${URLS.chat}/media/send/`, payload);
};

const downloadMedia = (roomId, eventId) => {
  return axiosInstance.get(`${URLS.chat}/media/download/`, {
    params: { room_id: roomId, event_id: eventId },
    responseType: "blob",
  });
};

export const chatApi = {
  listRooms,
  createGroupRoom,
  createTeamRoom,
  createDmRoom,
  fetchMessages,
  sendMessage,
  sendMedia,
  downloadMedia,
};
